const checkbox = document.getElementById('resize_checkbox')
const closeButton = document.getElementById('close_preview')
const screenWidth = window.screen.width
const screenHeight = window.screen.height
const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
const widthDiff = window.outerWidth - window.innerWidth
const spScreenWidth = 375 + widthDiff + scrollbarWidth

window.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.getElementById('resize_checkbox')
  const closeButton = document.getElementById('close_preview')
  const url = new URL(window.location.href)
  const shouldOpenMobilePreview = url.searchParams.get('preview_device') === 'mobile'

  if (checkbox) {
    if (shouldOpenMobilePreview || window.innerWidth < 989) {
      checkbox.checked = true
      window.resizeTo(spScreenWidth, screenHeight)
    }
    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        window.resizeTo(spScreenWidth, screenHeight)
      } else {
        window.resizeTo(screenWidth, screenHeight)
      }
    })
  }

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      console.log('close')
      window.close()
    })
  }
})

// プレビュー画面を引き延ばしたときに画面サイズによってcheckboxの状態を変化
if (checkbox) {
  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth
    if (currentWidth < 989) {
      checkbox.checked = true
    } else {
      checkbox.checked = false
    }
  })
}
